import FormikField from '../../1elements/Fields/FormikField'

const ProvinceSelect = ({name, className}) => {
    const values = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']

    return (
        <FormikField name={name} component="select" className={className}>
            {values.map((value)=>(
                <option value={value} key={value}>{value}</option>
            ))}
        </FormikField>
    )
}

export default ProvinceSelect
